module.exports = __webpack_public_path__ + "resources/creating-446449d03a8652a3b3e616503dbe15bf.svg";